import { alkymetricsClient } from '../alkymetricsClient';

export const createDashboardInvitation = async (body) => {
  const response = await alkymetricsClient.post('/dashboardInvitation', body);
  return response.data;
};

export const getDashboardInvitationsByRecruitSessionId = async (recruitSessionId) => {
  const response = await alkymetricsClient.get(`/dashboardInvitation/${recruitSessionId}`);
  return response;
};

export const softDeleteDashboardInvitation = async (recruitSessionId, guestEmail) => {
  const response = await alkymetricsClient.delete(
    `/dashboardInvitation/${recruitSessionId}/${guestEmail}`
  );
  return response;
};
